"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const n = (i) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...i,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8h20v2.54H2zm20 7.619H2v-2.54h20z",
        clipRule: "evenodd"
      }
    )
  }
), m = t(n);
export {
  m as QuickActionsAndroid,
  m as default
};
